import { Typography } from "@mui/material";

export const formatCurrency2Digit = (value) => {
  if (isNaN(value)) return "0.00";
  return Number(value).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const formatDateMonthYear = (date) => {
  if (!date) return "";
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  return new Date(date).toLocaleDateString("th-TH", options);
};

export const formatDateTime = (date, isMultiLine = true) => {
  if (!date) return "-";
  const optionsDate = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };

  const optionsTime = {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };

  const formattedDate = new Date(date).toLocaleDateString("th-TH", optionsDate);
  const formattedTime = new Date(date).toLocaleTimeString("th-TH", optionsTime);
  return isMultiLine ? (
    <Typography
      sx={{
        display: "inline",
        whiteSpace: "pre-line",
      }}
    >
      {formattedDate}
      {"\n"}เวลา {formattedTime} น.
    </Typography>
  ) : (
    `${formattedDate} เวลา ${formattedTime} น.`
  );
};
